import {AxiosResponse} from 'axios'
import httpClient from '@/services/httpClient'
import {
  AxiosResponseExternalReferralsInterface,
  AxiosResponseReferralsInterface,
  TransactionReferralHistoryInterface,
} from '@/types/types'

const ReferralsService = {
  getReferrals: (): Promise<AxiosResponse<AxiosResponseReferralsInterface[]>> =>
    httpClient.get('/referral'),
  getExternalReferrals: (): Promise<
    AxiosResponse<AxiosResponseExternalReferralsInterface[]>
  > => httpClient.get('/external_referral'),
  getChildren: (
    rootNumber: number
  ): Promise<
    AxiosResponse<
      {
        id: number
        name: string
        structure_counter: number
      }[]
    >
  > => httpClient.get(`/referral/${rootNumber}`),
  postTransfer: (data: string): Promise<AxiosResponse<any>> =>
    httpClient.post(`/referral/transfer?${data}`),
  postTransferWithCode: (data: string): Promise<AxiosResponse<any>> =>
    httpClient.post(`/referral/confirm_transfer?${data}`),
  refreshCode: (data: string): Promise<AxiosResponse<any>> =>
    httpClient.post(`/referral/transfer/refresh_code?${data}`),
  getReferralHistory: (
    rootNumber: number,
    page: number
  ): Promise<
    AxiosResponse<{
      pages: number
      total_amount: {HEXA: number; REEX: number}
      transactions: TransactionReferralHistoryInterface[]
    }>
  > =>
    httpClient.get(`/profile/user-referral-history/${page}`, {
      params: {
        root_number: rootNumber,
      },
    }),
  getReferralLoi: (): Promise<
    AxiosResponse<{refferals: string[]; unused_codes: string[]}>
  > => httpClient.get(`/mtl_refferal`),
  getReferralList: (): Promise<AxiosResponse<any>> =>
    httpClient.get('/referral_list'),
}

export default ReferralsService
